export enum MLSort {
  MOST_RELEVANT = 0,
  TOP_SELLERS = 1,
  SAVINGS_HIGH_TO_LOW = 2,
  PRICE_LOW_TO_HIGH = 3,
  PRICE_HIGH_TO_LOW = 4,
  TOP_RATED = 5,
  NEW_PRODUCTS = 6,
  BRAND = 7,
}
